<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >

      <login-card header-color="green">
        <h4 class="title text-center" slot="title">{{ formState === "forgotPassword" ? "Forgot Password" : "Reset Password" }}</h4>
        <!--
        <md-button
          slot="buttons"
          href="#facebook"
          class="md-just-icon md-simple md-white"
        >
          <i class="fab fa-facebook-square"></i>
        </md-button>

        <md-button
          slot="buttons"
          href="#twitter"
          class="md-just-icon md-simple md-white"
        >
          <i class="fab fa-twitter"></i>
        </md-button>
        -->
        <!-- <md-button
          slot="buttons"
          href="#google"
          class="md-just-icon md-simple md-black"
        >
          <i class="fab fa-google-plus-g"></i>
        </md-button> -->

        <p slot="description" class="description"></p>

        <template v-if="formState === 'forgotPassword'">

          <md-field class="md-form-group" slot="inputs" :class="[
                    { 'md-error': $v.form.username.$error },
                    { 'md-valid': !$v.form.username.$invalid },
                    { '_uiKitInput': isUiKit },
                  ]">
            <md-icon>account_circle</md-icon>
            <label>Email...</label>
            <md-input v-model.trim="$v.form.username.$model" type="email"></md-input>
            <md-icon v-if="$v.form.username.$error">clear</md-icon>
            <md-icon v-else-if="!$v.form.username.$invalid">done</md-icon> 
          </md-field>
          <md-button v-on:click="forgotPassword" :disabled="$v.form.$invalid || promisePending" slot="footer" class="md-simple md-success md-lg">
            Submit
          </md-button>
        </template>


        <template v-if="formState === 'resetPassword'">
          <md-field
            class="md-form-group" slot="inputs"
            :class="[
              { 'md-error': $v.formResetPassword.code.$error },
              { 'md-valid': !$v.formResetPassword.code.$invalid },
            ]"
          >
            <md-icon>vpn_key</md-icon>
            <label>Verification Code</label>
            <md-input v-model.trim="$v.formResetPassword.code.$model" />
              <md-icon v-if="$v.formResetPassword.code.$error">clear</md-icon>
              <md-icon v-else-if="!$v.formResetPassword.code.$invalid">done</md-icon>
          </md-field>

          <md-field class="md-form-group" slot="inputs" :class="[
                    { 'md-error': $v.formResetPassword.new_password.$error },
                    { 'md-valid': !$v.formResetPassword.new_password.$invalid },
                  ]">
            <md-icon>lock_outline</md-icon>
            <label>New Password...</label>
            <md-input v-model.trim="$v.formResetPassword.new_password.$model" type="password"></md-input>
            <md-icon v-if="$v.formResetPassword.new_password.$error">clear</md-icon>
            <md-icon v-else-if="!$v.formResetPassword.new_password.$invalid">done</md-icon> 
          </md-field>
          <md-field class="md-form-group" slot="inputs" :class="[
                    { 'md-error': $v.formResetPassword.confirm_password.$error },
                    { 'md-valid': !$v.formResetPassword.confirm_password.$invalid },
                  ]">
            <md-icon>lock_outline</md-icon>
            <label>Confirm Password...</label>
            <md-input v-model.trim="$v.formResetPassword.confirm_password.$model" type="password"></md-input>
            <md-icon v-if="$v.formResetPassword.confirm_password.$error">clear</md-icon>
            <md-icon v-else-if="!$v.formResetPassword.confirm_password.$invalid">done</md-icon> 
          </md-field>
          
          <md-button v-on:click="resetPassword" :disabled="$v.formResetPassword.$invalid || promisePending" slot="footer" class="md-simple md-success md-lg">
            Submit
          </md-button>
        </template>

      </login-card>
      <md-dialog-alert
      :md-active.sync="dialogStatus"
      :md-content="errorMessage" 
      md-confirm-text="Ok!" 
      @md-closed="errorMessage = ''"/>
    </div>
    <div class="dynamicList-loading"
          v-show="promisePending">
          <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
    </div>
  </div>
</template>
<script>

import { Auth, API, graphqlOperation } from "aws-amplify";
import { LoginCard } from "@/components";
// Form validations
import { required, numeric, minLength, email, sameAs } from "vuelidate/lib/validators";

export default {
  props: {
    isUiKit: {
      type: Boolean,
      default: () => true,
    },
  },
  components: {
   LoginCard,
  },
  data() {
    return {
      formState: "forgotPassword",
      errorMessage: "",
      promisePending: false,
      dialogStatus: false,
      form: {
        username: null,
        password: null
      },
      formResetPassword: {
        code: null,
        new_password: null,
        confirm_password: null
      },
    };
  },
  validations() {
      return {
        form: {
          username: {
            required, 
            email
          },
        },
        formResetPassword: {
          code: {required, numeric, minLength: minLength(6)},
          new_password: {required, minLength: minLength(6)},
          confirm_password: {required, sameAsPassword: sameAs('new_password')}
        }
      }
  },
  methods: {
    async forgotPassword() {
      this.promisePending = true;
      try{
        const { username } = this.form;
        await Auth.forgotPassword(username).then(data => {
          if (data.CodeDeliveryDetails.Destination) {
            this.formState = "resetPassword";
            /**
             * Using SetTimeout to reset validation 
             * @link https://vuelidate.js.org/#sub-delayed-validation-errors
             */
            setTimeout(() => {
              this.$v.formResetPassword.$reset();
            }, 100);
          }
          console.log('forgotPassword data ',data.CodeDeliveryDetails.Destination)
        }).catch(e => {
          console.log(e);
          this.dialogStatus = true;
          this.errorMessage = e.message;
          if(this.errorMessage == "User password cannot be reset in the current state."){
            this.errorMessage = "This account password cannot be reset, please login using your temporary password"
          }
        });
      } catch(e) {
        this.dialogStatus = true;
        this.errorMessage = e.message;
      }
      this.promisePending = false;
      console.log('this.errorMessage ',this.errorMessage);
      console.log('this.formState ',this.formState);
    },
    async resetPassword() {
      this.promisePending = true;
      this.errorMessage = "";
      try{
        const { username } = this.form;
        const { code, new_password } = this.formResetPassword;

        await Auth.forgotPasswordSubmit(
          username,
          code,
          new_password,           // the new password
        ).then(data => {
          console.log('Password reset successfully....');
          this.$router.push("/login"); 
        }).catch(e => {
          console.log(e);
          this.dialogStatus = true;
          this.errorMessage = e.message;
        });
      } catch(e) {
        this.dialogStatus = true;
        this.errorMessage = e.message;
      }
      this.promisePending = false;
      console.log(this.errorMessage);
      console.log(this.formState);
    }
  }
};
</script>

<style lang="css" scoped>
 .dynamicList-loading {
    position: absolute;
    top: 200px;
    left: 50%;
    transform:translateX(-50%);
    bottom: auto;
    right: auto;
    display: block;
    z-index:9999;
  }
</style>